/*
  404 - Page Not Found
  No Figma design. Styling reuses MIG style guide tokens:
  - Error code: h1-title (alfarn-2 180px)
  - Sub-heading: h2-large (alfarn-2 48px)
  - Body: body/large (Poppins Light 32px)
  - BACK button: UI/page-button (Poppins Bold 60px)
  Styling lives in src/styles/pages/error.css.
*/

export default function Error404() {
  return <ErrorPage code="404" title="Page not found" body="The page you are looking for has been removed, renamed or might never have existed. Please check the URL and try again." />
}

export function ErrorPage({ code, title, body }: { code: string; title: string; body: string }) {
  return (
    <section className="mig-error-section">
      <div className="mig-error-content">
        {/* Error code - h1-title */}
        <h1 className="mig-error-code">{code}</h1>

        {/* Sub-heading - h2-large */}
        <h2 className="mig-error-title">{title}</h2>

        {/* Body text */}
        <p className="mig-error-body">{body}</p>

        {/* BACK button */}
        <div className="mig-error-back-row">
          <a href="/" className="mig-error-back-button">BACK TO HOME</a>
          <div className="mig-divider-line" />
        </div>
      </div>
    </section>
  )
}
